var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseEyeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.384,
    height: 15.754,
    viewBox: "0 0 18.384 15.754",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon ionic-md-eye-off",
    d: "M11.444 7.815a4.167 4.167 0 0 1 4.181 4.148 3.99 3.99 0 0 1-.3 1.518l2.441 2.419a9.808 9.808 0 0 0 2.868-3.939A9.9 9.9 0 0 0 8.109 6.322l1.805 1.792a4.134 4.134 0 0 1 1.53-.299zM3.087 5.554l1.908 1.892.386.382a9.761 9.761 0 0 0-3.13 4.135A9.915 9.915 0 0 0 15.1 17.485l.353.349 2.449 2.421 1.066-1.055L4.145 4.5zm4.62 4.583L9 11.421a2.35 2.35 0 0 0-.066.537 2.494 2.494 0 0 0 2.507 2.486 2.358 2.358 0 0 0 .542-.066l1.3 1.284a4.159 4.159 0 0 1-6.019-3.709 4.1 4.1 0 0 1 .443-1.816zm3.6-.644 2.634 2.613.016-.131a2.494 2.494 0 0 0-2.507-2.486z",
    transform: "translate(-2.25 -4.5)",
    style: {
      fill: "#848484"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseEyeIcon);
export default __webpack_public_path__ + "static/media/close-eye-icon.7d5747b0.svg";
export { ForwardRef as ReactComponent };